const DEFAULT_ORIGIN = "http://localhost";

export const getSafeInternalRoute = (
  candidate,
  origin = typeof window !== "undefined" && window.location
    ? window.location.origin
    : DEFAULT_ORIGIN,
) => {
  if (typeof candidate !== "string") {
    return "/";
  }

  const trimmedCandidate = candidate.trim();
  if (!trimmedCandidate) {
    return "/";
  }

  try {
    const resolvedUrl = new URL(trimmedCandidate, origin);

    if (resolvedUrl.origin !== origin) {
      return "/";
    }

    return (
      `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}` || "/"
    );
  } catch {
    return "/";
  }
};
